import React from 'react';
import Hero from '../components/Hero';
import ResearchOverview from '../components/ResearchOverview';
import ResearchDetails from '../components/ResearchDetails';
import PrincipalInvestigator from '../components/PrincipalInvestigator';
import InTheNews from '../components/InTheNews';

const Home: React.FC = () => {
  return (
    <div>
      <Hero />
      <ResearchOverview />
      <ResearchDetails />
      <PrincipalInvestigator />
      <InTheNews />
    </div>
  );
};

export default Home;


